import React, { useMemo } from 'react';
import DataGrid from '../../common/DataGrid';

/**
 * Item grid — column definitions only.
 * Before: 146 lines.  After: ~45 lines.
 * More columns than other grids but same pattern.
 */
export default function ItemGrid(props) {
  const currencyFormatter = (params) => {
    if (params.value == null) return '';
    return params.value.toFixed(2);
  };

  const columns = useMemo(
    () => [
      { field: 'item_id', headerName: 'Item ID', minWidth: 150, flex: 0 },
      { field: 'sales_description', headerName: 'Sales Desc.', minWidth: 250, flex: 1 },
      { field: 'stock_no', headerName: 'Stock No.', maxWidth: 150, type: 'numericColumn' },
      { field: 'calculated_stock', headerName: 'Qty', maxWidth: 100, type: 'rightAligned' },
      { field: 'selling_price_incl', headerName: 'Price w/ Tax', maxWidth: 100, type: 'rightAligned', valueFormatter: currencyFormatter},
      { field: 'cost_excl', headerName: 'Cost w/o Tax', width: 100, type: 'rightAligned', valueFormatter: currencyFormatter },
      { field: 'selling_unit', headerName: 'Selling Unit', maxWidth: 100, type: 'numericColumn' },
      { field: 'selling_unit_name', headerName: 'Selling Unit Name', width: 100 },
      { field: 'purchase_unit', headerName: 'Purchase Unit', width: 100, type: 'numericColumn' },
      { field: 'purchase_unit_name', headerName: 'Purchase Unit Name', width: 100 },
      { field: 'sales_tax_code', headerName: 'Sales Tax', width: 100 },
      { field: 'purchase_tax_code', headerName: 'Purchase Tax', width: 100 },
      {
        field: 'category_id',
        headerName: 'Category',
        valueGetter: (params) => params.data.category?.category_name || params.data.category_id,
      },
      {
        field: 'supplier_id',
        headerName: 'Supplier',
        valueGetter: (params) => params.data.supplier?.supplier_name || params.data.supplier_id,
      },
    ],
    []
  );

  return (
    <DataGrid
      {...props}
      columns={columns}
      exportFileName="item_data.csv"
      rowHeight={35}
    />
  );
}
